import React from "react";
const footerContent = () => {
  return (
    <section className="footer-content">
      <div className="by-make">
        <h2>Rent car by Make</h2>
        <p>Maruti | Hyundai | Mahindra | Honda | Toyota | Ford</p>
      </div>
      <div className="by-model">
        <h2>Rent car by Model</h2>
        <p>
          City | Grand i10 | Scorpio | XUV | Baleno | Swift | Swift Dzire |
          Ertiga | Innova Crysta | Ciaz AT | Elite i20 | Creta | KUV100 | Alto
          K10 | Brezza | Marazzo | Santro MT | Santro AT | Swift AT | Brezza AT
          | Baleno AT | EcoSport | Celerio | Amaze | Ciaz | Verna AT | Verna MT
          | Creta AT | Venue AT | Baleno (P) | XUV300 (P) | XUV300 | Elite i20
          (P)
        </p>
      </div>

      <div className="by-Body-type">
        <h2>Rent car by Body Type</h2>
        <p>Hatchback | Sedan | SUV | MUV </p>
      </div>
    </section>
  );
};

export default footerContent;
